import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_accessorial_charges_templates_assigned_contracts_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { template_id: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, Enabled?: boolean, LookupCode?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, assigned_contracts?: { BillingContractLineId?: number, StrategyFieldName?: string, BillingContractLine?: { Id?: number, BillingAggregationStrategyId?: number, BillingContract?: { Id?: number, Name?: string, Project?: { Id?: number, LookupCode?: string, Owner?: { Id?: number, LookupCode?: string } } } } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_id)) {
      $missingRequiredInParams.push('\'template_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { template_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, Enabled?: boolean, LookupCode?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, assigned_contracts?: { BillingContractLineId?: number, StrategyFieldName?: string, BillingContractLine?: { Id?: number, BillingAggregationStrategyId?: number, BillingContract?: { Id?: number, Name?: string, Project?: { Id?: number, LookupCode?: string, Owner?: { Id?: number, LookupCode?: string } } } } }[] }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_id)) {
      $missingRequiredInParams.push('\'template_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { template_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, Enabled?: boolean, LookupCode?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, assigned_contracts?: { BillingContractLineId?: number, StrategyFieldName?: string, BillingContractLine?: { Id?: number, BillingAggregationStrategyId?: number, BillingContract?: { Id?: number, Name?: string, Project?: { Id?: number, LookupCode?: string, Owner?: { Id?: number, LookupCode?: string } } } } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_id)) {
      $missingRequiredInParams.push('\'template_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      template_id: number    }) {
        if(isNil($inParams.template_id)) {
          return true; 
        }
      return false;
    }
}
